module.exports = __webpack_public_path__ + "static/img/4.430f230.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/4.png
// module id = dpuH
// module chunks = 0